import { Component, ElementRef } from '@angular/core';
import {
  DesignAttributeType, ImageAttribute
} from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from '../../base/base-designer-component';

@Component({
  selector: 'sx-image-designer',
  templateUrl: './imageDesigner.component.html'
})
export class SxImageDesigner extends BaseDesignerComponent {

  constructor(container: ElementRef) {
    super(container, 'SxImage');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.assetCode = '';
    if(this.designerContext.product.codProducto){
      this.controlContext.prodCode = this.controlContext.prodCode;
    }else{
      this.controlContext.prodCode = '';
    }
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['assetCode'] = this.controlContext.assetCode;
    info['prodCode'] = this.controlContext.prodCode;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const prodCode = new DesignAttributeType(this.controlContext, 'string', 'prodCode', 'Product Code');
    const assetCode = new ImageAttribute(this.controlContext, 'assetCode', 'Asset Code');
    if(this.designerContext.product.codProducto) {
      prodCode.value = this.designerContext.product.codProducto;
      prodCode.isHidden = true;
    }

    this.attributes.push(prodCode);
    this.attributes.push(assetCode);
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/files-manager/imageDesigner.component.ts